const LOAD_DATA_MASTER_COUNTRIES           = 'LOAD_DATA_MASTER_COUNTRIES'
const LOAD_DATA_MASTER_COUNTRIES_SUCCESS   = 'LOAD_DATA_MASTER_COUNTRIES_SUCCESS'
const LOAD_DATA_MASTER_COUNTRIES_FAILED    = 'LOAD_DATA_MASTER_COUNTRIES_FAILED'
const UNMOUNT_DATA_MASTER_COUNTRIES        = 'UNMOUNT_DATA_MASTER_COUNTRIES'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const masterCountriesReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_MASTER_COUNTRIES:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_MASTER_COUNTRIES_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_MASTER_COUNTRIES_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_MASTER_COUNTRIES:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default masterCountriesReducer;